const presetComparator = (a, b) => {
  if (typeof a === 'number' && typeof b === 'number') return a - b;
  const aValue = a.toString().toUpperCase();
  const bValue = b.toString().toUpperCase();
  if (aValue < bValue) return -1;
  if (aValue > bValue) return 1;
  return 0;
};
const sortDataTableRows = (tableRows, columnIndex, comparator, ascendingOrder) => {
  const sortedData = [...tableRows].sort((a, b) => comparator(a.cells[columnIndex], b.cells[columnIndex]));
  const finalSortedData = ascendingOrder ? sortedData : sortedData.reverse();
  return finalSortedData;
};

export { presetComparator, sortDataTableRows };
